import { CalendarDays } from "lucide-react";
import React from "react";
import GradientBtn from "../WebsiteComponents/GradientBtn";
import { Skeleton } from "@mui/material";

interface IProps {
  orderId?: string;
  message?: string;
  date?: string;
  result?: number[];
  onViewDetails?: () => void;
  skeleton?: boolean;
  read?: boolean;
}

const ResultBox = ({ result, color }: { result: number; color: string }) => {
  return (
    <div
      className="flex items-center justify-center w-[18px] h-[18px] lg:w-[1.3vw] lg:h-[1.3vw] rounded-full"
      style={{ backgroundColor: color }}
    >
      <p className="font-size-14px font-Poppins-Regular text-white">{result}</p>
    </div>
  );
};

const MyResultsCard: React.FC<IProps> = ({
  orderId,
  message,
  date,
  result,
  onViewDetails = () => {},
  skeleton = false,
  read = false,
}) => {
  let color = {
    green: "#4BB206",
    orange: "#FE5910",
    red: "#FF221C",
    default: "#3E3E3E",
  };
  return (
    <div className={`w-full side-bar-padding flex flex-col side-bar-gap border border-[#D5D5D5] rounded-md shadow-all-light ${!read ? "unread-highlight" : "bg-white"}`}>
      {skeleton ? (
        <>
          <div className="flex items-center justify-between">
            <Skeleton variant="text" width="20%" height={24} />
          </div>
          <Skeleton variant="text" width="60%" height={20} />
          <div className="flex items-center justify-between">
            <Skeleton variant="rectangular" width={80} height={16} />
            <div className="flex items-center gap-1">
              <Skeleton
                variant="rectangular"
                width={20}
                height={20}
                sx={{ borderRadius: 4 }}
              />
              <Skeleton variant="rectangular" width={60} height={20} />
            </div>
          </div>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={36}
            sx={{ borderRadius: 8 }}
          />
        </>
      ) : (
        <>
          <div className="flex items-center justify-between">
            <p className="theme-color-green-3b font-size-16px font-Poppins-Regular">
              {orderId}
            </p>
          </div>
          <p className="font-size-16px font-Poppins-Medium theme-color-green-20">
            {message || ""}
          </p>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1">
              <CalendarDays size={16} color="#3E3E3E" />
              <p className="font-size-14px font-Poppins-Regular text-[#3E3E3E]">
                {date || "N/A"}
              </p>
            </div>
            <div className="flex items-center gap-1">
              <p className="font-size-14px font-Poppins-Medium flex items-center gap-1 theme-color-green-20">
                Result :{" "}
                <div className="flex items-center gap-1">
                  {result?.map((item, index) => (
                    <ResultBox
                      key={index}
                      result={item}
                      color={
                        index === 0
                          ? "#4BB206"
                          : index === 1
                          ? "#FE5910"
                          : "#FF221C"
                      }
                    />
                  ))}
                </div>
              </p>
            </div>
          </div>
          <GradientBtn ButtonText="View Result" onPress={onViewDetails} />
        </>
      )}
    </div>
  );
};

export default MyResultsCard;
